<div class="usage-goal-panel">
  <div class="usage-goal-header bold">
    <fa-icon class="usage-goal-icon print-icon" [icon]="clockIcon"></fa-icon> Usage Goal
  </div>
  <div class="section-description-small">Shows the average amount of time your student has practiced since starting WordFlight. Our goal is to stay above {{ minWeeklyTimeGoal }} minutes per week.</div>
  <div class="usage-goal-stat usage-goal-stat-gray">
    <div class="usage-goal-number">{{ minWeeklyTimeGoal }}<span class="usage-goal-unit">min</span></div>
    <div class="section-description-small">Minimum Weekly Usage Goal</div>
  </div>
  <div class="usage-goal-stat usage-goal-stat-blue">
    <div class="usage-goal-number">{{ (avgWeeklyUsage > 0) ? (avgWeeklyUsage | number: '1.0-0') : "0" }}<span class="usage-goal-unit">min</span></div>
    <div class="section-description-small">Average Weekly Usage</div>
  </div>
</div>
